export const getScopeArray = () => (localStorage.getItem('scope') || '').split(' ');

export const hasAccess = (rule) => getScopeArray().includes(rule);

export const getCaseDownloadPermissions = () => ({
    canDownloadOrderIntegrationUploadZip: hasAccess('cases.orderintegrationuploadzip:download'),
    canDownloadPrescription: hasAccess('cases.prescriptions:download'),
    canUpdateCaseStatus: hasAccess('cases.status:write'),
    canDownloadSTL: hasAccess('cases.scans:download'),
});
